import Checkbox from '../../components/checkbox/checkbox';
import SearchBox from '../../components/searchBox/searchBox';

const queryString = require('query-string');

class FileArchive {
    constructor(el) {
        this.el = el;

        const searchBoxElement = document.querySelector('.searchBox');

        if (searchBoxElement) {
            this.searchBox = new SearchBox(searchBoxElement);
        }

        this.currentSearch = '';

        this.state = {
            currentFilter: 'all',
            activeTermBox: null,
            items: [],
            openIndex: null
        };

        this.checkboxes = [];
        this.files = [];

        this.bindEvents();
    }

    bindEvents() {
        if (this.searchBox) {
            this.searchBox.on('search', (value) => this.searchHandler(value));
        }
    }

    initArchive() {
        const filters = this.el.querySelectorAll('.checkbox');

        for (let i = 0; i < filters.length; i++) {
            const checkbox = new Checkbox(filters[i]);
            this.checkboxes.push(checkbox);
            checkbox.on('changed', () => this.filterChanged(checkbox));
        }

        this.files = this.el.querySelectorAll('.file');
    }

    render() {
        for (let i = 0; i < this.files.length; i++) {
            console.log(this.files[i].dataset['name']);
            console.log(this.currentSearch);
            let hidden = false;
            if (this.state.currentFilter !== 'all' && this.files[i].dataset['categories'] !== this.state.currentFilter) {
                hidden = true;
            } else if (this.currentSearch !== '' && this.files[i].dataset['name'].toLowerCase().indexOf(this.currentSearch) === -1) {
                hidden = true;
            }

            if (hidden) {
                this.files[i].parentElement.classList.add('hidden');
            } else {
                this.files[i].parentElement.classList.remove('hidden');
            }
        }
    }

    setFiltersFromUrl() {
        const parsed = queryString.parse(window.location.search);

        if (parsed.filters) {
            this.state.currentFilter = parsed.filters;
            this.setFiltersFromState();
            this.setActiveTermBox();
        }
    }

    filterChanged(checkbox) {
        if (checkbox.id === this.state.currentFilter) {
            this.state.currentFilter = 'all';
        } else {
            this.state.currentFilter = checkbox.id;
        }

        this.setFiltersFromState();
        this.updateUrl();
        this.render();
    }

    setFiltersFromState() {
        for (let i = 0; i < this.checkboxes.length; i++) {
            const checkbox = this.checkboxes[i];
            if (this.state.currentFilter !== checkbox.id) {
                checkbox.setInactive();
            } else {
                checkbox.setActive();
            }
        }
    }

    searchHandler(keyword) {
        if (keyword.length > 2) {
            this.currentSearch = keyword;
            this.render();
        } else if (this.currentSearch !== '') {
            this.currentSearch = '';
            this.render();
        }
    }

    updateUrl() {
        const hasFilters = this.state.currentFilter !== 'all';
        let newString = '';

        if (hasFilters) {
            newString += '?filters=' + this.state.currentFilter;
        }

        if (hasFilters && this.state.openIndex !== null) {
            newString += '&';
        } else if (!hasFilters && this.state.openIndex !== null) {
            newString += '?';
        }

        if (this.state.openIndex !== null) {
            newString += 'open=' + this.state.openIndex;
        }

        window.history.replaceState(
            null,
            '',
            window.location.href.split('?')[0] + (newString || '')
        );
    }
}

let el = document.querySelector('.fileArchive');
let fileArchive = null;

if (!el) {
    el = document.querySelector('.fileArchive__columns');
}

if (el) {
    fileArchive = new FileArchive(el);
    window.fileArchive = fileArchive;
}

export default fileArchive;



// WEBPACK FOOTER //
// ./src/pages/fileArchive/fileArchive.js